import { remove } from 'lodash-es';
import { makeAutoObservable, runInAction } from 'mobx';

type ComparedItem = {
  fields: Record<string, any>;
  data?: any;
};

export class ElectricStore {
  comparedItems: ComparedItem[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async addItem(item: ComparedItem) {
    runInAction(() => {
      this.comparedItems.push(item);
    });
  }

  async removeItem(index: number) {
    runInAction(() => {
      remove(this.comparedItems, (_item, idx) => index === idx);
    });
  }
}
